import axios from 'axios';

// URL base dell'API per le fasi, recuperato dall'env file
const INTERVALLOPUNTEGGIO_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'intervalli-punteggio';

// Definizione dell'header per le richieste con JSON
const headers = { 'Content-Type': 'application/json' };

class IntervalloPunteggioService {


    
    getIntervalloBySondaggioId(sonId) {
        return axios.get(INTERVALLOPUNTEGGIO_REST_API_URL + "/sondaggio/" + sonId, { headers });
    }

     
    saveIntervalloPunteggio(intervallo) {
        return axios.post(INTERVALLOPUNTEGGIO_REST_API_URL,  intervallo, { headers });
    }

    deleteIntervalloPunteggio(intPunId) {
        return axios.delete(INTERVALLOPUNTEGGIO_REST_API_URL +"/" + intPunId, { headers });
    }


}
// Creazione dell'istanza per essere importata direttamente nei componenti
const intervalloPunteggioServiceInstance = new IntervalloPunteggioService();
export default intervalloPunteggioServiceInstance;
